import { emptyError } from "../../../Types/ServicesType/servicesType";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";

const { clinicId } = getConstants();
type Filter = {
  search: string;
};
type RequestData = {
  clinicId: number;
  filter: Filter;
  pageNumber: number;
  pageSize: number;
};
const { nursingApi } = api;
export const getpatientProcedureList = async (body: RequestData) => {
  try {
    const result = await instance.post(nursingApi.getProcedureList, body);
    return result.data.response;
  } catch (error) {
    return emptyError;
  }
};
export const getpatientProcedure = async (id: number) => {
  try {
    const result = await instance.get(
      `${nursingApi.getProcedure}${clinicId}?id=${id}`,
    );
    return result.data.response;
  } catch (error) {
    return emptyError;
  }
};

export const updateNursingProcedure = async (body: any) => {
  console.log("body", body);

  try {
    const result = await instance.post(nursingApi.updateNursing, body);
    return result.data;
  } catch (error) {}
};
